export const QUEUED = 'queued';
export const PREPARING = 'preparing';
export const CREATING_CHANGE_SET = 'creatingChangeSet';
export const CHANGE_SET_CREATED = 'changeSetCreated';
export const DEPLOYING = 'deploying';
export const DEPLOYED = 'deployed';
export const UNDEPLOYED = 'undeployed';
export const FAILING = 'failing';
export const FAILED = 'failed';
